export default __webpack_public_path__ + "static/biker-title-image-min-7189f761b0d93b63ffda06ba849289d3.jpg";